import React from "react";
import PropTypes from "prop-types";

const IntegrationError = ({ dataError, displayStatus }) => (
  <>
    <div>{dataError}</div>
    <div>
      <b>Status:</b> {displayStatus}
    </div>
  </>
);

IntegrationError.propTypes = {
  dataError: PropTypes.string,
  displayStatus: PropTypes.string
};

export default IntegrationError;
